/* Store Image Animations
document.addEventListener('DOMContentLoaded', function() {
    const waveOverlay = document.querySelector('.wave-overlay');
    const storeOverlay = document.querySelector('.store-overlay');
    const lightsOverlay = document.querySelector('.lights-overlay');
    let storeScale = 1;
    let waveScale = 1;
    let lastScrollY = window.scrollY;
    let animationComplete = false;
    let isScrolling = false;
    
    // Initial load animation
    if (waveOverlay && storeOverlay && lightsOverlay) {
        const storeImage = storeOverlay.querySelector('img');
        
        const startAnimation = () => {
            // First show wave
            waveOverlay.classList.add('show');
            
            // Then show store and lights after delay
            setTimeout(() => {
                storeOverlay.classList.add('show');
                lightsOverlay.classList.add('show');
                
                // Wait for initial animations to fully complete
                setTimeout(() => {
                    animationComplete = true;
                    lastScrollY = window.scrollY;
                }, 1000);
            }, 800);
        };

        if (storeImage?.complete) {
            setTimeout(startAnimation, 500);
        } else {
            storeImage.onload = () => setTimeout(startAnimation, 500);
        }
    }

    // Scroll handler with improved smoothing
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        if (!animationComplete) return;
        
        clearTimeout(scrollTimeout);
        isScrolling = true;
        
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;
        
        // Increased minimum scroll threshold for smoother feel
        if (Math.abs(currentScrollY - lastScrollY) < 8) return;
        
        // Smaller increments for smoother scaling
        if (scrollingDown) {
            storeScale = Math.min(1.15, storeScale + 0.005);
            waveScale = Math.min(1.175, waveScale + 0.004);
        } else {
            storeScale = Math.max(1.0, storeScale - 0.005);
            waveScale = Math.max(1.0, waveScale - 0.004);
        }
        
        // Apply transforms only if we're actually scaling
        if (storeScale !== 1 || waveScale !== 1) {
            requestAnimationFrame(() => {
                storeOverlay.style.setProperty('transform', 
                    `translateX(-50%) translateY(0) scale(${storeScale})`, 
                    'important'
                );
                lightsOverlay.style.setProperty('transform', 
                    `translateX(-50%) translateY(0) scale(${storeScale})`, 
                    'important'
                );
                waveOverlay.style.setProperty('transform',
                    `translateY(0) scale(${waveScale})`,
                    'important'
                );
            });
        }
        
        lastScrollY = currentScrollY;
        
        // Smoother reset with longer delay
        scrollTimeout = setTimeout(() => {
            if (!isScrolling) return;
            isScrolling = false;
            
            // Gradual reset
            const resetInterval = setInterval(() => {
                const resetComplete = storeScale === 1 && waveScale === 1;
                if (resetComplete) {
                    clearInterval(resetInterval);
                    return;
                }
                
                storeScale = Math.max(1, storeScale - 0.002);
                waveScale = Math.max(1, waveScale - 0.002);
                
                requestAnimationFrame(() => {
                    storeOverlay.style.setProperty('transform', 
                        `translateX(-50%) translateY(0) scale(${storeScale})`, 
                        'important'
                    );
                    lightsOverlay.style.setProperty('transform', 
                        `translateX(-50%) translateY(0) scale(${storeScale})`, 
                        'important'
                    );
                    waveOverlay.style.setProperty('transform',
                        `translateY(0) scale(${waveScale})`,
                        'important'
                    );
                });
            }, 16); // ~60fps
        }, 200);
    }, { passive: true });
});
*/

// Pre-order modal for collection / listing pages
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('preorder-modal');
    if (!modal) return;

    const modalCheckbox = document.getElementById('preorder-modal-checkbox');
    const modalLabel = document.getElementById('preorder-modal-label');
    const confirmBtn = document.getElementById('preorder-modal-confirm');
    const cancelBtn = document.getElementById('preorder-modal-cancel');
    let pendingBtn = null;
    let preorderConfirmed = false;

    function openModal(btn) {
        pendingBtn = btn;
        modalCheckbox.checked = false;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.hidden = true;
        pendingBtn = null;
        modalCheckbox.checked = false;
        document.body.style.overflow = '';
    }

    // Intercept clicks on pre-order card buttons
    document.addEventListener('click', function(e) {
        if (preorderConfirmed) return;

        const btn = e.target.closest('[name="add"], .js-quick-add');
        if (!btn) return;

        const card = btn.closest('.card--product-preorder');
        if (!card) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        openModal(btn);
    }, true); // capture phase so we fire before product-form.js

    confirmBtn.addEventListener('click', function() {
        if (!modalCheckbox.checked) {
            modalCheckbox.classList.remove('checkbox-pulse');
            modalLabel.classList.remove('text-focus');
            void modalCheckbox.offsetWidth;
            modalCheckbox.classList.add('checkbox-pulse');
            modalLabel.classList.add('text-focus');
            return;
        }

        const btn = pendingBtn;
        closeModal();

        if (!btn) return;

        preorderConfirmed = true;
        btn.click();
        preorderConfirmed = false;
    });

    cancelBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
});

// Pre-order checkbox validation and animation
document.addEventListener('DOMContentLoaded', function() {
    const checkbox = document.getElementById('preorder-confirmation');
    const addToCartButton = document.querySelector('[name="add"]');
    const label = document.getElementById('preorder-label');
    const container = document.querySelector('.pre-order-info');

    if (checkbox && addToCartButton && label) {
        addToCartButton.addEventListener('click', function(event) {
            if (!checkbox.checked) {
                event.preventDefault();
                
                // Remove existing animations
                container.classList.remove('attention-pulse');
                checkbox.classList.remove('checkbox-pulse');
                label.classList.remove('text-focus');
                
                // Force reflow
                void container.offsetWidth;
                void checkbox.offsetWidth;
                void label.offsetWidth;
                
                // Add animations
                container.classList.add('attention-pulse');
                checkbox.classList.add('checkbox-pulse');
                label.classList.add('text-focus');
            }
        });
    }
});

/* // Add after existing slideshow code
document.addEventListener('DOMContentLoaded', function() {
    const lightsImage = document.querySelector('.lights-overlay img');
    if (!lightsImage) return;

    let glowIntensity = 1;
    let glowDirection = 1;
    
    function updateGlow() {
        // Reduced random flicker chance from 0.1 to 0.05
        if (Math.random() < 0.05) {
            // Reduced intensity range from 0.8-1.2 to 0.9-1.1
            glowIntensity = 0.9 + Math.random() * 0.2;
        } else {
            // Reduced step size from 0.02 to 0.01
            glowIntensity += 0.01 * glowDirection;
            // Reduced max/min range from 1.2/0.8 to 1.1/0.9
            if (glowIntensity >= 1.1) glowDirection = -1;
            if (glowIntensity <= 0.9) glowDirection = 1;
        }
        
        lightsImage.style.filter = `
            brightness(${glowIntensity})
            drop-shadow(0 0 ${1 + glowIntensity * 2}px rgba(255, 255, 255, ${0.2 + glowIntensity * 0.1}))
        `;
        lightsImage.style.opacity = '0.65'; // Changed base transparency to 0.65
        
        requestAnimationFrame(updateGlow);
    }
    
    updateGlow();
});

// Slideshow animation
document.addEventListener('DOMContentLoaded', () => {
    const storeOverlay = document.querySelector('.store-overlay');
    const lightsOverlay = document.querySelector('.lights-overlay');
    const waveOverlay = document.querySelector('.wave-overlay');

    // Add show classes after a short delay
    setTimeout(() => {
        if (storeOverlay) storeOverlay.classList.add('show');
        if (lightsOverlay) lightsOverlay.classList.add('show');
        if (waveOverlay) waveOverlay.classList.add('show');
    }, 500);

    // Start flickering animation after slide-up
    setTimeout(() => {
        if (lightsOverlay) {
            const lightsImage = lightsOverlay.querySelector('img');
            if (lightsImage) {
                lightsImage.style.animation = 'flicker 4s linear infinite';
            }
        }
    }, 1300); // Wait for slide-up animation to complete
});
*/

/* Collection filter bar helpers */
document.addEventListener('DOMContentLoaded', () => {
  const stripBadFormatOptions = () => {
    document.querySelectorAll('.collection-filters-container select.cf-select').forEach((select) => {
      [...select.options].forEach((option) => {
        if (/great copy from a real record shop/i.test(option.textContent || '')) {
          option.remove();
        }
      });
    });
  };

  // Convert theme custom-select sort into a native <select> so it matches Filterific.
  const convertSortToNativeSelect = (sortWrap) => {
    if (!sortWrap) return null;
    const existing = sortWrap.querySelector('select.smr-sort-select');
    if (existing) return existing;

    const optionEls = [...sortWrap.querySelectorAll('.custom-select__option')];
    if (!optionEls.length) return null;

    const labelEl = sortWrap.querySelector('label');
    const labelText = (labelEl && labelEl.textContent.trim()) || 'Sort by';

    const select = document.createElement('select');
    select.className = 'cf-select smr-sort-select';
    select.id = 'smr-products-sort-by';
    select.setAttribute('aria-label', labelText);

    optionEls.forEach((optEl) => {
      const option = document.createElement('option');
      option.value = optEl.dataset.value || '';
      option.textContent = (optEl.textContent || '').trim();
      if (optEl.getAttribute('aria-selected') === 'true') option.selected = true;
      select.appendChild(option);
    });

    // Prefer current URL sort_by if present
    const currentSort = new URL(window.location.href).searchParams.get('sort_by');
    if (currentSort) select.value = currentSort;

    select.addEventListener('change', () => {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', select.value);
      window.location.href = urlObj.toString();
    });

    sortWrap.classList.add('smr-sort-native');
    sortWrap.innerHTML = '';

    const label = document.createElement('span');
    label.className = 'smr-sort-label';
    label.textContent = labelText;
    sortWrap.appendChild(label);
    sortWrap.appendChild(select);

    return select;
  };

  // Keep sort as a sibling of Filterific (not inside it) so re-renders can't wipe it.
  // Also works on search pages (sort only — no Filterific).
  const mergeSortIntoFilterRow = () => {
    const filters = document.querySelector('.collection-filters-container');
    const sort =
      document.querySelector('.smr-collection-controls > .products-toolbar__sort') ||
      document.querySelector('#products-toolbar .products-toolbar__sort');
    const toolbar = document.querySelector('#products-toolbar');
    if (!sort && !filters) return;

    let bar = document.querySelector('.smr-collection-controls');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'smr-collection-controls';
      if (filters) {
        filters.parentNode.insertBefore(bar, filters);
        bar.appendChild(filters);
      } else if (toolbar) {
        toolbar.parentNode.insertBefore(bar, toolbar);
      } else if (sort) {
        sort.parentNode.insertBefore(bar, sort);
      }
    } else if (filters && !bar.contains(filters)) {
      bar.insertBefore(filters, bar.firstChild);
    }

    if (sort && !bar.contains(sort)) {
      bar.appendChild(sort);
    }

    if (sort) convertSortToNativeSelect(sort);

    if (
      toolbar &&
      !toolbar.querySelector(
        '.products-toolbar__sort, .products-toolbar__filter, .products-toolbar__layout, .products-toolbar__compare'
      )
    ) {
      toolbar.hidden = true;
    }
  };

  stripBadFormatOptions();
  mergeSortIntoFilterRow();
  setTimeout(stripBadFormatOptions, 500);
  setTimeout(mergeSortIntoFilterRow, 500);
  setTimeout(stripBadFormatOptions, 1500);
  setTimeout(mergeSortIntoFilterRow, 1500);
});

